/**
 * Extract filename from Content-Disposition header
 * @param {String} header Header string
 * @returns {String} Extracted filename
 */
export default function (header) {
  return header.match(/filename="(.+)"/)[1]
}
